import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Fornecedor } from '../models/fornecedor';

@Injectable({
  providedIn: 'root',
})
export class FornecedorService {
  //Url da API

  private url = `${environment.apiUrl}/fornecedores`;

  constructor(private readonly http: HttpClient) {}

  selecionar(): Observable<Fornecedor[]> {
    return this.http.get<Fornecedor[]>(this.url);
  }

  cadastrar(obj: Fornecedor): Observable<Fornecedor> {
    return this.http.post<Fornecedor>(this.url, obj);
  }

  alterar(id: number | null, obj: Fornecedor): Observable<Fornecedor> {
    // Backend espera PUT /api/fornecedores com o objeto completo no corpo
    return this.http.put<Fornecedor>(this.url, obj);
  }

  ativarDesativar(id: number, ativo: boolean = false): Observable<Fornecedor> {
    return this.http.patch<Fornecedor>(`${this.url}/${id}/ativo?ativo=${ativo}`, null as any);
  }
}
